const IPV4_PATTERN = /^(?:\d{1,3}\.){3}\d{1,3}$/
const IPV6_HEX_GROUP_PATTERN = /^[0-9a-f]{1,4}$/
const IPV4_MAPPED_SUFFIX_PATTERN = /:(\d{1,3}(?:\.\d{1,3}){3})$/

const isIpv4Address = (value: string): boolean => IPV4_PATTERN.test(value)

const isIpv6Address = (value: string): boolean => {
  if (!value.includes(':') || value.includes(':::')) {
    return false
  }

  if ((value.startsWith(':') && !value.startsWith('::')) || (value.endsWith(':') && !value.endsWith('::'))) {
    return false
  }

  let candidate = value
  const ipv4Mapped = candidate.match(IPV4_MAPPED_SUFFIX_PATTERN)
  if (ipv4Mapped?.[1]) {
    if (!isIpv4Address(ipv4Mapped[1])) {
      return false
    }

    candidate = `${candidate.slice(0, -ipv4Mapped[1].length)}0`
  }

  const compressionCount = candidate.match(/::/g)?.length ?? 0
  if (compressionCount > 1) {
    return false
  }

  const groups = candidate.split(':')
  const hexGroups = groups.filter(Boolean)
  if (hexGroups.some((group) => !IPV6_HEX_GROUP_PATTERN.test(group))) {
    return false
  }

  if (compressionCount === 1) {
    return hexGroups.length <= 7
  }

  return groups.length === 8 && hexGroups.length === 8
}

export const isIpHostname = (hostname: string): boolean => {
  const value = hostname.trim().toLowerCase()
  const unbracketed = value.replace(/^\[|\]$/g, '')

  return isIpv4Address(unbracketed) || isIpv6Address(unbracketed)
}
